var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#424242","fillRule":"evenodd","d":"M16.128 9.666a.5.5 0 1 1 .744.668l-4.5 5a.5.5 0 0 1-.744 0l-4.5-5a.5.5 0 0 1 .744-.668L12 14.253l4.128-4.587z"}));
}

ChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
